import { render, staticRenderFns } from "./PermissionsIcon.vue?vue&type=template&id=10860901&scoped=true&"
import script from "./PermissionsIcon.vue?vue&type=script&lang=js&"
export * from "./PermissionsIcon.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsIcon.vue?vue&type=style&index=0&id=10860901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10860901",
  null
  
)

component.options.__file = "PermissionsIcon.vue"
export default component.exports